export { default as Channel } from './Channel';
export { default as Faq } from './Faq';
export { default as Hero } from './Hero';
export { default as Share } from './Share';
export { default as Wish } from './Wish';
